import { render, staticRenderFns } from "./Nested.vue?vue&type=template&id=2e3807dc&scoped=true&"
import script from "./Nested.vue?vue&type=script&lang=js&"
export * from "./Nested.vue?vue&type=script&lang=js&"
import style0 from "./Nested.vue?vue&type=style&index=0&id=2e3807dc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e3807dc",
  null
  
)

export default component.exports